export default __webpack_public_path__ + "static/media/witheredblasphemy.4f3dd524.png";